(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subasta-inversa-doble"] && !Shopify.designMode) return;
  try {
    
  {
    class ReverseAuction {
      constructor(container) {
        this.container = container;
        if (!this.container) return;

        this.sectionId = this.container.dataset.sectionId;
        this.startTimeString = this.container.dataset.startTime;
        this.endTimeString = this.container.dataset.endTime;
        this.stockBarMax = parseInt(this.container.dataset.stockBarMax, 10) || 20;

        if (!this.startTimeString || !this.endTimeString) return;

        this.startTime = new Date(this.startTimeString).getTime();
        this.endTime = new Date(this.endTimeString).getTime();
        this.totalDuration = this.endTime - this.startTime;
        this.productCards = this.container.querySelectorAll('.auction-product-card');

        this.init();
      }

      init() {
        this.updateAuction();
        this.interval = setInterval(() => this.updateAuction(), 100);
      }

      updateAuction() {
        const now = new Date().getTime();

        if (now < this.startTime) {
          this.updateCountdown(this.startTime - now);
        } else if (now > this.endTime) {
          clearInterval(this.interval);
          // Ocultar toda la sección cuando el countdown ha caducado
          this.container.style.display = 'none';
        } else {
          this.updateCountdown(this.endTime - now);
          this.updatePrices(now);
        }
      }

      updateCountdown(timeRemaining) {
        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        document.getElementById(`days-${this.sectionId}`).textContent = String(days).padStart(2, '0');
        document.getElementById(`hours-${this.sectionId}`).textContent = String(hours).padStart(2, '0');
        document.getElementById(`minutes-${this.sectionId}`).textContent = String(minutes).padStart(2, '0');
        document.getElementById(`seconds-${this.sectionId}`).textContent = String(seconds).padStart(2, '0');
      }

      updatePrices(now) {
        const timeElapsed = now - this.startTime;
        let timeProgress = timeElapsed / this.totalDuration;
        if (timeProgress > 1) timeProgress = 1;
        if (timeProgress < 0) timeProgress = 0;

        this.productCards.forEach((card, index) => {
          const i = index + 1;
          const initialPrice = parseFloat(card.dataset.initialPrice);
          const minimumPrice = parseFloat(card.dataset.minimumPrice);

          const totalPriceDrop = initialPrice - minimumPrice;
          const currentPriceDrop = totalPriceDrop * timeProgress;
          let currentPrice = initialPrice - currentPriceDrop;

          if (currentPrice < minimumPrice) currentPrice = minimumPrice;

          const priceElement = document.getElementById(`current-price-${this.sectionId}-${i}`);
          if (priceElement) {
            priceElement.textContent = `S/ ${(currentPrice / 100).toFixed(4)}`;

            // Siempre aplicar la animación de parpadeo
            priceElement.classList.add('price--critical');
          }

          // Actualizar el enlace de WhatsApp con el precio actual
          const whatsappButton = document.getElementById(`whatsapp-button-${this.sectionId}-${i}`);
          if (whatsappButton) {
            const productTitle = card.querySelector('.auction-product--info a')?.textContent || 'este producto';
            const currentPriceFormatted = `S/ ${(currentPrice / 100).toFixed(2)}`;
            const whatsappNumber = this.container.dataset.whatsappNumber;

            const message = encodeURIComponent(
              `Hola! Me interesa "${productTitle}". Precio actual: ${currentPriceFormatted}`
            );
            whatsappButton.href = `https://wa.me/${whatsappNumber}?text=${message}`;
          }
        });
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.auction-container').forEach((container) => {
        new ReverseAuction(container);
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
